{
  "version": 1,
  "asset_id": "251b0718-8ca3-47db-a921-6eb96bfe81dd",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/251b0718-8ca3-47db-a921-6eb96bfe81dd/svc-link-building-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/251b0718-8ca3-47db-a921-6eb96bfe81dd/svc-link-building-640.avif",
  "original_filename": "svc-link-building-640.avif",
  "size": 6431,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:50Z"
}
